import { render } from "./ProdutosDetalheView.vue?vue&type=template&id=3cc9431b"
import script from "./ProdutosDetalheView.vue?vue&type=script&lang=js"
export * from "./ProdutosDetalheView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__